import { Bone } from 'common/components/Bone'
import styles from './styles.module.sass'

export const UsersActionsSkeleton = () => {
  const renderUserList = (titleWidth: number, count: number) => (
    <div className={styles.userList}>
      <Bone width={titleWidth} height={12} />
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={styles.userStyles}>
          <Bone width={32} height={32} radius={40} className={styles.avatar} />
          <div className={styles.info}>
            <Bone width={i === 0 ? 107 : 142} height={20} />
          </div>
          <div className={styles.actions}>
            <Bone width={39} height={18} />
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <div className={styles.usersActionsSkeleton}>
      {renderUserList(89, 2)}
      {renderUserList(134, 4)}
    </div>
  )
}
